import { apiPost } from '../api'

export const issue_doctors_note = data => {
  return apiPost({
    endpoint: 'attendance/issue_doctors_note',
    data: data
  })
}
